var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('ProjectList'),_c('br'),_c('br'),_c('IndexList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }